import "../styles/chat.css";
import io from "socket.io-client";
import { useState } from "react";
import Chat from "../components/chat";

const socket = io.connect("https://socket-ades.herokuapp.com/");
//const socket = io.connect("http://localhost:3001");

function ChatScreen() {
    const [username, setUsername] = useState("");
    const [room, setRoom] = useState("");
    const [showChat, setShowChat] = useState(false);
  
    const joinRoom = () => {
      if (username !== "" && room !== "") {
        socket.emit("join_room", room);
        setShowChat(true);
      }
    };
  
    return (
      <div className="Chat">
        {!showChat ? (
          <div className="joinChatContainer">
            <h3>&nbsp;&nbsp;Support</h3>
            <input
              type="text"
              placeholder="                            Name"
              onChange={(event) => {
                setUsername(event.target.value);
              }}
            />
            <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;Choose Department</h4>
            <input
              type="text"
              placeholder="                   Sales or Support  "
              onChange={(event) => {
                setRoom(event.target.value);
              }}
            />
            <button onClick={joinRoom}>Start Chatting&nbsp;<i class="bi bi-chat-text"></i></button>
          </div>
        ) : (
          <Chat socket={socket} username={username} room={room} />
        )}
      </div>
    );
  }

export default ChatScreen;